import { render, staticRenderFns } from "./SpecialDialog.vue?vue&type=template&id=bef0c800&scoped=true&"
import script from "./SpecialDialog.vue?vue&type=script&lang=js&"
export * from "./SpecialDialog.vue?vue&type=script&lang=js&"
import style0 from "./SpecialDialog.vue?vue&type=style&index=0&id=bef0c800&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef0c800",
  null
  
)

export default component.exports